import Container from '@material-ui/core/Container'
import React, { FC } from 'react'
import { NewsroomPostContainer, NewsroomTeaserContainer } from './style'

//* utils
import { ComponentAnnouncement } from '../../../../../models/components/announcement'
import { ComponentMainNavBanner } from '../../../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../../../models/others/menuGroup'

//* components
import Hero from '../../../../global/hero'
import SEOTags from '../../../../global/seoTags'
import Layout from '../../../../layouts/layout'
import { getHeroProps, getSocialMediaBoilerPlate, getTeaserMarkup } from './subcomponent/markups'
import { PostContent } from './subcomponent/postContent'

type Props = {
  path: string
  pageContext: any
  location?: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  mainNavBannerData?: ComponentMainNavBanner
  browserLanguageData?: any
}

const NewsroomPost: FC<Props> = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  if (!pageContext.postData) return null
  const { seoMetadata, node_locale, slug, body, title, h1Title, date, microcopy, pageName } =
    pageContext.postData

  const heroProps = getHeroProps(date, microcopy, node_locale, title || h1Title)
  const twoTeasers = Array.isArray(pageContext.twoTeasers) ? pageContext.twoTeasers : []
  const teaserMarkup = getTeaserMarkup(twoTeasers, node_locale)
  const socialMediaBoilerPlate = getSocialMediaBoilerPlate(
    pageContext.socialMediaBoilerPlate?.contentEntries
  )

  return (
    <Layout.Template
      lang={node_locale}
      pageType="newsroomPost"
      slug={slug}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      availableLocales={pageContext.availableLocales}>
      <div data-cy="NewsroomPost">
        <SEOTags
          seoMetadata={seoMetadata}
          path={path}
          slug={slug}
          locale={node_locale}
          availableLocales={pageContext.availableLocales}
        />

        <NewsroomPostContainer>
          <Hero
            // @ts-ignore
            data={heroProps}
            location={location}
            pageTitle={pageName}
            showBreadcrumbs={true}
            pageType="flex"
            locale={node_locale}
            breadcrumb={pageContext.postData.breadcrumb}
          />

          <Container>
            <PostContent
              title={title}
              slug={slug}
              body={body}
              pressReleaseBoilerPlate={pageContext.pressReleaseBoilerPlate}
            />
          </Container>

          {teaserMarkup && <NewsroomTeaserContainer>{teaserMarkup}</NewsroomTeaserContainer>}
          {socialMediaBoilerPlate}
        </NewsroomPostContainer>
      </div>
    </Layout.Template>
  )
}

export default NewsroomPost
